import Api from 'api';

import { GET_ROLES_LIST, GET_PERMISSIONS_LIST } from 'containers/lists/constants';

export const getRolesList = (companyId) => ({
  type: GET_ROLES_LIST,
  payload: Api.roles.getRolesList(companyId),
});

export const getPermissionsList = (companyId) => ({
  type: GET_PERMISSIONS_LIST,
  payload: Api.roles.getPermissionsList(companyId),
});

export const getPermissionsListAll = (companyId) => ({
  type: GET_PERMISSIONS_LIST,
  payload: Api.roles.getPermissionsListAll(companyId),
});



// WEBPACK FOOTER //
// src/containers/lists/actions.js